<script setup lang="ts">
import { AppText } from '@shared/ui/typography'

defineOptions({
  name: 'DisciplineBalanceCard',
})

defineProps<{
  title: string
}>()
</script>

<template>
  <div class="discipline-balance-card">
    <div class="discipline-balance-card__head">
      <AppText name="body1-medium">
        {{ title }}
      </AppText>
      <slot name="subtitle" />
    </div>
    <div class="discipline-balance-card__list">
      <slot />
    </div>
    <div
      v-if="$slots.options"
      class="discipline-balance-card__options"
    >
      <slot name="options" />
    </div>
  </div>
</template>

<style scoped lang="scss" src="./DisciplineBalanceCard.scss" />
